import React from "react";
import { Navigate } from "react-router-dom";

// AuthenticationInner pages (optional – can remove later if unused)
import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
import CoverSignIn from "../pages/AuthenticationInner/Login/CoverSignIn";

import Bookings from "../pages/Landing/NFTLanding/Bookings";

import Cart from "../pages/Landing/NFTLanding/Cart";
import Reviews from "../pages/Landing/NFTLanding/Reviews"


const authProtectedRoutes = [];

const publicRoutes = [
  // ✅ ROOT → BOOKINGS
  { path: "/", component: <Navigate to="/apps-bookings" /> },

  // 🔹 App pages
  { path: "/apps-bookings", component: <Bookings /> },
 

  { path: "/apps-cart", component: <Cart /> },
  // (Optional) keep auth inner pages only if needed
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/guest-review", component: <Reviews /> },
];

export { authProtectedRoutes, publicRoutes };
